import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3333 13.3332H2.66659C1.93325 13.3332 1.33325 12.7332 1.33325 11.9998V3.99984C1.33325 3.2665 1.93325 2.6665 2.66659 2.6665H13.3333C14.0666 2.6665 14.6666 3.2665 14.6666 3.99984V11.9998C14.6666 12.7332 14.0666 13.3332 13.3333 13.3332Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 2.6665H2.66659C1.93325 2.6665 1.33325 3.2665 1.33325 3.99984L7.99992 8.6665L14.6666 3.99984C14.6666 3.2665 14.0666 2.6665 13.3333 2.6665Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})]
});
export default SvgMailOutline;
